/**
 * ViewerLayout.js
 * The structural wrapper for the Webtoon Viewer.
 * Handles background setup and main container constraints.
 */
export const ViewerLayout = ({ isEmbedded = false } = {}) => {
    const container = document.createElement('div');

    // Base Classes
    let classes = "w-full min-h-screen bg-zinc-900 text-gray-200 flex flex-col font-sans relative bg-cover bg-center bg-no-repeat bg-fixed";

    if (isEmbedded) {
        classes = "w-full flex flex-col font-sans bg-zinc-900 text-gray-200 relative";
        container.className = classes;
    } else {
        container.className = classes;
        container.style.backgroundImage = "url('/login.webp')";
        container.style.backgroundBlendMode = "overlay";
        container.classList.add('bg-zinc-900/90', 'backdrop-blur-sm');
    }

    return container;
};
